import { useEffect, useState, useCallback } from 'react'

import { useSessionContext } from 'hooks/SessionContext'

import Api from 'services/api'

import { DeprovisionedHehmDevice } from 'types/DeprovisionedHehmDevice'

const useDeprovisionedDevices = (refresh?: number) => {
  const { session: { impersonateDealerId, dealerId } } = useSessionContext()
  const resolvedDealerId = impersonateDealerId || dealerId

  const [deprovisionedDevices, setDeprovisionedDevices] = useState<DeprovisionedHehmDevice[]>([])
  const [isDeprovisionedDevicesLoaded, setIsDeprovisionedDevicesLoaded] = useState(false)

  const fetchDeprovisionedDevices = useCallback(async () => {
    setIsDeprovisionedDevicesLoaded(false)
    try {
      const devices = await Api.HomeHealth.getDeprovisionedDevices(String(resolvedDealerId))
      setDeprovisionedDevices(devices || [])
    } catch {
      setDeprovisionedDevices([])
    } finally {
      setIsDeprovisionedDevicesLoaded(true)
    }
  }, [resolvedDealerId])

  useEffect(() => {
    fetchDeprovisionedDevices()
  }, [fetchDeprovisionedDevices, refresh])

  return {
    deprovisionedDevices,
    isDeprovisionedDevicesLoaded,
    refreshDeprovisionedDevices: fetchDeprovisionedDevices
  }
}

export default useDeprovisionedDevices
